export function capitalizeFirstLetter(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function lowercaseFirstLetter(string: string): string {
    return string.charAt(0).toLowerCase() + string.slice(1);
}

export function getSemesterNumberForStudyId(studyId: number): number {
    switch (studyId) {
        case 1:
        case 3:
        case 5:
        case 6:
        case 11:
        case 13:
            return 6
        case 2:
        case 4:
        case 7:
        case 8:
        case 10:
        case 12:
        case 14:
            return 4
        case 9:
            return 8
        default:
            return 8
    }
}

function semestersSliceSize(array: number[]): number {
    if (array.length < 2 || (array[1] - array[0] > 1)) {
        return 1
    }
    return 2
}

export function semestersSliceBegin(currentStudentSemester: number, array: number[]): number {
    if (array[1] - array[0] > 1) {
        return Math.floor(currentStudentSemester/2.0)
    }
    return currentStudentSemester - 1
}

export function semestersSliceEnd(currentStudentSemester: number, array: number[]): number {
    return semestersSliceBegin(currentStudentSemester, array) + semestersSliceSize(array)
}

export function groupBy<TItem>(data: TItem[], key: string): { [key: string]: TItem[] } {
    // `data` is an array of objects, `key` is the key (or property accessor) to group by
    // reduce runs this anonymous function on each element of `data` (the `item` parameter,
    // returning the `storage` parameter at the end
    return data.reduce(function (storage, item) {
        // get the first instance of the key by which we're grouping
        // @ts-ignore
        let group: any = capitalizeFirstLetter(item[key]);

        // set `storage` for this instance of group to the outer scope (if not empty) or initialize it
        // @ts-ignore
        storage[group] = storage[group] || [];

        // add this item to its group within `storage`
        // @ts-ignore
        storage[group].push(item);

        // return the updated storage to the reduce function, which will then loop through the next
        return storage;
    }, {}); // {} is the initial value of the storage
}